import { NextPage } from 'next'
import dynamic from 'next/dynamic'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import React from 'react'

import { getFloatingMenu } from '@/services/apps'
import { getPpidSubmissionList } from '@/services/ppid'
import { getPpidInformationHowToGets, getPpidInformationHowToObtain } from '@/services/ppid-information-request'
import { wrapper } from '@/store'
const RequestInformation = dynamic(() => import('./RequestInformation'), { ssr: false })

const Page: NextPage = () => {
  return (
    <main className='min-h-screen overflow-x-hidden bg-[#FCFCFC] lg:bg-white'>
      <RequestInformation />
    </main>
  )
}

export const getProps = wrapper.getServerSideProps((store) => async ({ locale }) => {
  const paramsList = {
    params: { skip: 0, limit: 1000 },
    headers: { 'Accept-Language': String(locale) },
  }
  await Promise.all([
    store.dispatch(getPpidInformationHowToObtain.initiate(paramsList)),
    store.dispatch(getPpidInformationHowToGets.initiate(paramsList)),
    store.dispatch(getPpidSubmissionList.initiate(paramsList)),

    store.dispatch(getFloatingMenu.initiate({ headers: { ...paramsList.headers } })),
  ])
  return {
    props: {
      ...(await serverSideTranslations(String(locale), ['common', 'service-ppid', 'service-ppid-request-information'])),
    },
  }
})

export default Page
